import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "yadid_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// Public
export const submitInquiry = async (payload) => {
  const res = await axios.post(`${API}/contact`, payload);
  return res.data;
};

export const fetchInsights = async () => {
  const res = await axios.get(`${API}/insights`);
  return res.data;
};

export const fetchInsight = async (slug) => {
  const res = await axios.get(`${API}/insights/${slug}`);
  return res.data;
};

// Auth
export const adminLogin = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  setToken(res.data.token);
  return res.data;
};

export const adminMe = async () => {
  const res = await axios.get(`${API}/auth/me`, authHeaders());
  return res.data;
};

// Admin CRUD
export const adminListInsights = async () => {
  const res = await axios.get(`${API}/admin/insights`, authHeaders());
  return res.data;
};

export const adminCreateInsight = async (article) => {
  const res = await axios.post(`${API}/admin/insights`, article, authHeaders());
  return res.data;
};

export const adminUpdateInsight = async (slug, article) => {
  const res = await axios.put(`${API}/admin/insights/${slug}`, article, authHeaders());
  return res.data;
};

export const adminDeleteInsight = async (slug) => {
  const res = await axios.delete(`${API}/admin/insights/${slug}`, authHeaders());
  return res.data;
};

// Journeys
export const fetchJourney = async (slug) => {
  const res = await axios.get(`${API}/journeys/${slug}`);
  return res.data;
};

export const adminListJourneys = async () => {
  const res = await axios.get(`${API}/admin/journeys`, authHeaders());
  return res.data;
};

export const adminUpdateJourney = async (slug, images) => {
  const res = await axios.put(`${API}/admin/journeys/${slug}`, images, authHeaders());
  return res.data;
};

export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/admin/upload`, fd, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  return `${BACKEND_URL}${res.data.url}`;
};
